import { z } from "zod";
// A program's admin-configured feedback settings: how many questions to draw
// at random from that program's question pool per response (#351), and
// whether those questions are asked before or after the standard ratings.
// Settings are stored only where somebody chose them, so a program nobody has
// touched is served the defaults and still has a value on this screen.
export const ProgramConfigSchema = z.object({
    id: z.string(),
    name: z.string(),
    randomQuestionCount: z.number().int().min(1),
    // false: the standard ratings come first, program questions after. true:
    // program questions lead the form.
    programQuestionsFirst: z.boolean(),
});
export const ProgramConfigsResponseSchema = z.object({
    programConfigs: ProgramConfigSchema.array(),
});
// The write body for PUT /api/admin/program-config/:id — the URL owns the id.
// Both fields are stated together: the admin screen saves a program's whole
// config in one PUT, not one field at a time.
export const UpdateProgramConfigSchema = ProgramConfigSchema.pick({
    randomQuestionCount: true,
    programQuestionsFirst: true,
});
